export default __webpack_public_path__ + "static/hq4-d39a30a7aac92208481bc33874cb6527.jpg";